import Vue from 'vue';
import {checkEndpointForPdf, updateWindowEndpoints} from "@/mixins/endpointUpdatesForPdf";

module.exports = {
  token: null,
  retryRequests: {},

  intercept: function(request, next) {
    if (window.environment === 'local') {
        request.root = checkEndpointForPdf(request.root)
        updateWindowEndpoints()
    }

    let getToken = function() {
      let tokenString = localStorage.getItem('token');
      let token = '';

      try {
          token =
              tokenString === null || tokenString.length < 4
                  ? ''
                  : JSON.parse(tokenString);
      } catch (e) {
          token = '';
      }

      // check local storage in case
      if (token == null && localStorage.getItem('token')) {
        token = JSON.parse(localStorage.getItem('token'));
      }
      return token;
    };

    // #319 Parse token from JSON only if has a valid length token). Otherwise this will fail on non-Chrome browsers.
    module.exports.token = getToken();
    if (module.exports.token)
      request.headers.set('Authorization', 'Bearer ' + module.exports.token);

    next(res => {
      let hasAuthHeader =
        typeof request.headers.map.Authorization !== 'undefined';

      let requestData =
        request.method +
        request.root +
        request.url +
        JSON.stringify(request.body) +
        JSON.stringify(request.params);

      let requestHash = requestData.split('').reduce(function(a, b) {
        a = (a << 5) - a + b.charCodeAt(0);
        return a & a;
      }, 0);

      if (res.status === 401 && hasAuthHeader) {
        if (localStorage.getItem('tokenized')) {
          return;
        }

        // don't retry same request twice
        if (typeof module.exports.retryRequests[requestHash] !== "undefined") {
          return;
        }

        let sentToken = request.headers.map.Authorization[0]
          .split(' ')
          .splice(-1)[0];

        if (sentToken !== getToken() || !window.token_loaded) {
          module.exports.retryRequests[requestHash] = 1;

          return new Promise((resolve, reject) => {
            let interval;

            let waitForToken = function() {
              if (window.token_loaded) {
                request.headers.set('Authorization', 'Bearer ' + getToken());
                resolve(Vue.http(request));
                clearInterval(interval);
              } else {
                  reject(res);
              }
            };

            interval = setInterval(waitForToken, 100);
          });
        }
      } else {
        delete module.exports.retryRequests[requestHash];
      }
    });
  },
};
